/* ----------------------------------------------------------------------------
   M7 — Courier Overcharge Errors · dummy data (local to this module).
   Mirrors the DEMO_ROWS / template / tolerance from the mockup js/m7.js.
   "billed"   = what the courier invoiced on the AWB.
   "expected" = the governing ProShip rate card for that code / zone / slab.
   variance   = billed − expected; flagged as an overcharge when variance > ₹5.
   Frontend-only, in-memory, no network.
   ---------------------------------------------------------------------------- */

/* ₹5 tolerance per TRD — variances above this are flagged as errors */
export const TOL = 5

/* CSV template served by the file-drop (one row per AWB) */
export const TEMPLATE_NAME = 'overcharge-invoice-template.csv'
export const TEMPLATE_CONTENT =
  'awb,courier_code,vertical,zone,billed_weight_kg,billed_amount\n' +
  'AWB74830001,Delhivery_ENT_SURFACE,D2C,Zone 1,0.45,32\n' +
  'AWB74830002,Delhivery_ENT_SURFACE,D2C,Zone 3,0.48,71\n' +
  'AWB74830003,BlueDart_AIR_PRIME,D2C,Zone 4,1.80,148\n' +
  'AWB74830004,Xpressbees_SURFACE,D2C,Zone 2,0.92,54\n' +
  'AWB74830005,Ekart_SURFACE,D2C,Zone 1,0.40,49\n'

/* dummy variance rows — the intended output of the variance engine */
export const DEMO_ROWS = [
  {
    awb: 'AWB74830001',
    courier: 'Delhivery',
    cpCode: 'Delhivery_ENT_SURFACE',
    vertical: 'D2C',
    zone: 'Zone 1',
    slab: '0–0.5 kg',
    billed: 32,
    expected: 32,
    agreement: 'Addendum #2',
  },
  {
    awb: 'AWB74830002',
    courier: 'Delhivery',
    cpCode: 'Delhivery_ENT_SURFACE',
    vertical: 'D2C',
    zone: 'Zone 3',
    slab: '0–0.5 kg',
    billed: 71,
    expected: 49,
    agreement: 'Addendum #2',
  },
  {
    awb: 'AWB74830003',
    courier: 'Blue Dart',
    cpCode: 'BlueDart_AIR_PRIME',
    vertical: 'D2C',
    zone: 'Zone 4',
    slab: '1–2 kg',
    billed: 148,
    expected: 132,
    agreement: 'MSA',
  },
  {
    awb: 'AWB74830004',
    courier: 'Xpressbees',
    cpCode: 'Xpressbees_PTL',
    vertical: 'PTL',
    zone: 'Zone 2',
    slab: '0–10 kg',
    billed: 280,
    expected: 280,
    agreement: 'Addendum #1',
  },
  {
    awb: 'AWB74830005',
    courier: 'Ekart',
    cpCode: 'Ekart_SURFACE',
    vertical: 'D2C',
    zone: 'Zone 1',
    slab: '0–0.5 kg',
    billed: 49,
    expected: 36,
    agreement: 'Addendum (pending)',
  },
  {
    awb: 'AWB74830006',
    courier: 'Delhivery',
    cpCode: 'Delhivery_ENT_SURFACE',
    vertical: 'D2C',
    zone: 'Zone 5',
    slab: '0–0.5 kg',
    billed: 78,
    expected: 74,
    agreement: 'Addendum #2',
  },
  {
    awb: 'AWB74830007',
    courier: 'Blue Dart',
    cpCode: 'BlueDart_AIR_PRIME',
    vertical: 'D2C',
    zone: 'Zone 1',
    slab: '0–0.5 kg',
    billed: 96,
    expected: 84,
    agreement: 'MSA',
  },
  {
    awb: 'AWB74830008',
    courier: 'Xpressbees',
    cpCode: 'Xpressbees_SURFACE',
    vertical: 'D2C',
    zone: 'Zone 2',
    slab: '0.5–1 kg',
    billed: 54,
    expected: 53,
    agreement: 'Addendum #1',
  },
]

export const variance = (r) => Math.round((r.billed - r.expected) * 100) / 100
export const isError = (r) => variance(r) > TOL
